export const EventType2 = {
    Playback: "playback",
    Sender: "sender",
    Relay: "relay",
    Audio: "audio"
}

export const EventType1 = {
    Automation: "automation",
    ControlledBy: "control",
    // ThirdParty: "third",
}

export const ConfigurationMap = [
    {id: "auto", name: "Automation", variant: "primary"},
    {id: "ctrl", name: "Controlled By", variant: "primary"},
    {id: "third", name: "Third-Party", variant: "primary"},
    {id: "undef", name: "Undefined", variant: "secondary"},
]

// Not used anymore
// export const RelayMap = {
//     RelayNano: 1,
//     RelayMulti: 4
// }

export const RelayAction = [
    {id: 0, name: "Switch Off"},
    {id: 1, name: "Switch On"},
    {id: 2, name: "Impulse"},
]

export const DeviceProject = {
    NanoEth: "nano-eth",
    MicroEth: "micro-eth",
    StandardEth: "std-eth",
    RelayNano: "relay-nano",
    AudioNano: "audio-nano",
    ButtonNano: "button-nano",
    SensorTemperature: "sensor-temp",
    SensorHumidity: "sensor-humidity",
}

export const ProjectMap = [
    {
        project: "std-eth", configure: [
            {title: "Playback", path: "playback", event_type2: EventType2.Playback},
            {title: "Sender", path: "sender", event_type2: EventType2.Sender}
        ]
    },
    {
        project: "nano-eth", configure: [
            {title: "Playback", path: "playback", event_type2: EventType2.Playback}
        ]
    },
    {
        project: "micro-eth", configure: [
            {title: "Playback", path: "playback", event_type2: EventType2.Playback}
        ]
    },
    {
        project: "audio-nano", configure: [
            {title: "Playback", path: "playback", event_type2: EventType2.Playback}
        ]
    },
    {
        project: "button-nano", configure: []
    },
    {
        project: "relay-nano", configure: [
            {title: "Relay 1", index: 1, path: "relay1", event_type2: EventType2.Relay}
        ]
    },
    {
        project: "relay-multi", configure: [
            {title: "Relay 1", path: "relay1", event_type2: EventType2.Relay},
            {title: "Relay 2", path: "relay2", event_type2: EventType2.Relay},
            {title: "Relay 3", path: "relay3", event_type2: EventType2.Relay},
            {title: "Relay 4", path: "relay4", event_type2: EventType2.Relay}
        ]
    },
]

export const PaymentMethods = {
    Bank: "bank",
    PayPal: "paypal",
    Bitcoin: "bitcoin"
}